import React from 'react';
import { Clock, Download, GitCompare, History } from 'lucide-react';
interface HeaderProps {
  onViewHistorical: () => void;
  onCompare: () => void;
  onExport: () => void;
}
export function Header({
  onViewHistorical,
  onCompare,
  onExport
}: HeaderProps) {
  return <header className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-276">
      <div data-id="element-277">
        <h1 className="text-3xl font-bold text-white tracking-tight mb-2" data-id="element-278">
          AVP Closing Performance
        </h1>
        <div className="flex items-center gap-3 text-sm flex-wrap" data-id="element-279">
          <span className="text-slate-400 font-medium" data-id="element-280">
            April 2026 Performance
          </span>
          <div className="flex items-center gap-2 px-2.5 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-300" data-id="element-281">
            <span className="relative flex h-2 w-2" data-id="element-282">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75" data-id="element-283"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500" data-id="element-284"></span>
            </span>
            In Progress
          </div>
          <span className="inline-flex items-center gap-1.5 text-slate-500" data-id="element-285">
            <Clock className="w-3.5 h-3.5" data-id="element-286" />
            Auto-stamps on April 30
          </span>
          <span className="text-slate-500" data-id="element-287">· Last refreshed: Just now</span>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3" data-id="element-288">
        <button onClick={onViewHistorical} className="flex items-center gap-2 px-4 py-2 rounded-lg glass-panel hover:bg-white/10 text-slate-300 text-sm font-medium transition-colors" data-id="element-289">
          <History className="w-4 h-4" data-id="element-290" />
          Historical
        </button>
        <button onClick={onCompare} className="flex items-center gap-2 px-4 py-2 rounded-lg glass-panel hover:bg-white/10 text-slate-300 text-sm font-medium transition-colors" data-id="element-291">
          <GitCompare className="w-4 h-4" data-id="element-292" />
          Compare
        </button>
        <button onClick={onExport} className="flex items-center gap-2 px-4 py-2 rounded-lg glass-panel hover:bg-white/10 text-slate-300 text-sm font-medium transition-colors" data-id="element-293">
          <Download className="w-4 h-4" data-id="element-294" />
          Export
        </button>
      </div>
    </header>;
}